export function normalizeMovimentoItemPayload(item) {
    return {
        id: item.id,
        uuid: item.uuid,
        empresaId: item.empresaId,
        movimentoId: item.movimentoId,

        produtoId: item.produtoId,
        embalagemId: item.embalagemId,
        tabelaPrecoId: item.tabelaPrecoId,
        almoxarifadoId: item.almoxarifadoId,

        quantidade: item.quantidade,
        fator: item.fator,

        prato: item.prato,
        precoBase: item.precoBase,
        precoNegociado: item.precoNegociado,
        precoPorUnidade: item.precoPorUnidade,
        valorUnitario: item.valorUnitario,
        valorTotal: item.valorTotal,

        descontoPercentual: item.descontoPercentual,
        descontoValor: item.descontoValor,
        descontoFinanceiro: item.descontoFinanceiro,
        descontoFinanceiroPercentual: item.descontoFinanceiroPercentual,

        custo: item.custo,
        custoCalculado: item.custoCalculado,

        pesoBruto: item.pesoBruto,
        pesoLiquido: item.pesoLiquido,
        pesoMolecular: item.pesoMolecular,
        volume: item.volume,

        ncmId: item.ncmId,
        tributacaoId: item.tributacaoId,
        cfopId: item.cfopId,

        icmsAliquota: item.icmsAliquota,
        icms: item.icms,
        ipiAliquota: item.ipiAliquota,
        ipi: item.ipi,
        fecoepAliquota: item.fecoepAliquota,
        fecoep: item.fecoep,
        icmsST: item.icmsST,
        fecoepST: item.fecoepST,
        mva: item.mva,

        pedido: item.pedido,
        ativo: item.ativo,
        observacao: item.observacao,

        // XML, se precisar manter vínculo
        chNFe: item.chNFe,
        nItem: item.nItem,
        cProd: item.cProd,
        xProd: item.xProd,
        cEAN: item.cEAN,
        cEANTrib: item.cEANTrib,
        uCom: item.uCom,
        uTrib: item.uTrib,
        qCom: item.qCom,
        qTrib: item.qTrib,
        vUnCom: item.vUnCom,
        vUnTrib: item.vUnTrib,
        vProd: item.vProd,
        cfop: item.cfop,
    };
}
